import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getOtherChargeItemList(params) {
  return request({
    url: URL.mdm.basicData.otherChargeItem,
    method: 'get',
    params
  })
}

export function saveOtherChargeItem(data) {
  return request({
    url: URL.mdm.basicData.otherChargeItem,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delOtherChargeItem(uuid) {
  return request({
    url: URL.mdm.basicData.otherChargeItem + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
